import { ActionCardWebElementBase } from './ActionCardWebElementBase';
import { By } from 'selenium-webdriver';

/**
 * The component WebElement for [oj-c-action-card](../../jsdocs/oj-c.ActionCard.html).
 * Do not instantiate this class directly, instead, use
 * [findActionCard](../functions/findActionCard.html).
 */
export class ActionCardWebElement extends ActionCardWebElementBase {
  // Put overrides here

  /**
   * Perform a click on the button
   */
  doAction() {
    return this.click();
  }

  /**
   * Perform a click on the button
   */
  async click() {
    // Find the <button> element to click so that it can receive focus
    const button = await this.findElement(By.css('[role=button]'));
    return button.click();
  }
}
